import React from "react"
import { ProvidersType } from "@/types/providers.types"
import ProviderRankCard from "./components/ProviderRankCard"
import ProviderTag from "./components/ProviderTag"
import { DisplayProvider } from "@/UI"
import { DispatchRuleType } from "@/types/dispatchRules.types"

interface ProvidersListProps {
  providers: (ProvidersType | string)[]
  type: DispatchRuleType
  view?: "full" | "compact"
  className?: string
}

const ProvidersList: React.FC<ProvidersListProps> = ({
  providers,
  type,
  view = "full",
  className,
}) => {
  return (
    <>
      {type === DispatchRuleType.RANK ? (
        <div
          className={`${className} flex flex-col border rounded-lg ${
            view === "full" ? "p-4 space-y-2 mt-8" : "p-1 space-y-1 mt-3"
          }`}
        >
          {providers.map((provider, index) => {
            const isProvider = Object.keys(ProvidersType).find(
              (providerName) => providerName === provider
            )
            return (
              <div
                className={`group flex w-full rounded-lg border justify-between items-center select-none ${
                  view === "full" ? "px-4 py-3" : "px-2 py-1"
                }`}
              >
                <ProviderRankCard
                  type={isProvider ? "provider" : "team"}
                  name={provider}
                  provider={provider as ProvidersType}
                  rank={index + 1}
                />
              </div>
            )
          })}
        </div>
      ) : (
        <div
          className={`${className} flex flex-wrap border rounded-lg ${
            view === "full" ? "px-4 py-3" : "px-2 py-1"
          }`}
        >
          {providers.map((provider) => {
            const isProvider = Object.keys(ProvidersType).find(
              (providerName) => providerName === provider
            )
            return view === "full" ? (
              <ProviderTag
                type={isProvider ? "provider" : "team"}
                name={provider}
                provider={provider as any}
                className="font-normal text-sm"
              />
            ) : (
              <>
                {isProvider ? (
                  <DisplayProvider
                    provider={provider as ProvidersType}
                    fontStyle="font-normal"
                    showName={false}
                    className="mr-2"
                  />
                ) : (
                  <p className="font-semibold">{provider}</p>
                )}
              </>
            )
          })}
        </div>
      )}
    </>
  )
}

export default ProvidersList
